exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body { margin-top:20px; }\r\n.panel-title {display: inline;font-weight: bold;}\r\n.checkbox.pull-right { margin: 0; }\r\n.pl-ziro { padding-left: 0px; }\r\n\r\n.alert-message\r\n{\r\n    margin: 20px 0;\r\n    padding: 20px;\r\n    border-left: 3px solid #eee;\r\n}\r\n.alert-message h4\r\n{\r\n    margin-top: 0;\r\n    margin-bottom: 5px;\r\n}\r\n.alert-message p:last-child\r\n{\r\n    margin-bottom: 0;\r\n}\r\n.alert-message code\r\n{\r\n    background-color: #fff;\r\n    border-radius: 3px;\r\n}\r\n.alert-message-success\r\n{\r\n    background-color: #F4FDF0;\r\n    border-color: #3C763D;\r\n}\r\n.alert-message-success h4\r\n{\r\n    color: #3C763D;\r\n}\r\n.alert-message-danger\r\n{\r\n    background-color: #fdf7f7;\r\n    border-color: #d9534f;\r\n}\r\n.alert-message-danger h4\r\n{\r\n    color: #d9534f;\r\n}\r\n\r\nhtml, body, .container-table {\r\n   height: 100%;\r\n}\r\n.container-table {\r\n   display: table;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /tmp/build_713add00/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main